import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

/**
 * Komponent SVG dla obszaru C - sedan widok prawy
 */
export const AreaC_Sedan_Right: React.FC<AreaSVGProps> = ({
  fill = '#73C69B',
  stroke = '#73C69B',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="104"
      height="145"
      viewBox="0 0 104 145"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_c_sedan_right"
          x="0"
          y="0"
          width="104"
          height="145"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>

      <g filter="url(#filter_area_c_sedan_right)">
        <path
          d="M13.3198 143.807C19.3951 143.336 26.0433 140.373 39.062 133.219C42.1422 131.526 45.5434 129.622 49.3354 127.498C61.1314 120.892 76.6838 112.182 98.0093 101.21C98.4164 100.711 99.1846 99.4918 99.9282 97.1631C100.824 94.3572 101.539 90.3905 101.654 85.2754C101.777 79.784 102.209 58.9152 102.549 39.2471C102.719 29.4117 102.867 19.8874 102.94 12.7393C102.977 9.16228 102.995 6.19818 102.989 4.09375C102.988 3.941 102.988 3.7929 102.987 3.65039C101.297 3.42548 98.6359 3.1498 94.3374 2.7168C88.4838 2.12714 74.4463 1.18376 59.6157 1.02344C44.5813 0.860915 29.5098 1.52238 21.1431 3.85742C19.4407 4.33286 17.7542 4.82497 16.1382 5.2959C13.2045 6.15081 10.4791 6.94291 8.36865 7.42969C6.85626 28.7195 3.18344 85.7471 1.03076 136.314C4.19714 137.753 6.55517 139.93 8.10596 141.357C8.48505 141.706 8.80506 142 9.08252 142.237C9.91223 142.946 10.4857 143.317 11.0239 143.535C11.5077 143.731 12.19 143.894 13.3198 143.807Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
